var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[(_vm.name + "_dark")] = Boolean(_vm.label), _obj )},[_vm._v("\n  "+_vm._s(_vm.label || _vm.$t('adgroup_scheduling'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }